<template>
  <div class="card-box" @click="toRegister" ref="viewPointcontainer">
    <div
      v-for="(item) in filterPointList"
      :key="item.newsId"
      :class="['item', 'carousel-normal-item']"
    >
      <div class="item-content-box">
        <div class="item-head" v-html="item.newsTitle">
        </div>
        <div class="item-main" v-html="item.content"></div>
      </div>
      <div class="item-bottom">{{ item.updateTime  }}</div>
    </div>
    <empty-box v-if="!filterPointList || filterPointList.length === 0" />
  </div>
</template>

<script>
import EmptyBox from '@/components/EmptyBox/index.vue'

export default {
  components:{
    EmptyBox
  },
  props: {
    viewPointList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      carouselPriceIndex: 1,
      setTodoFun: null,
    };
  },
  computed: {
    filterPointList() {
      let resList = [];
      let res2List = [];

      this.viewPointList.forEach((item) => {
        item.content = this.filterPContent(item.content);
        resList.push(item);
      });

      resList.forEach((item) => {
        let title = item.newsTitle;
        let findItem = res2List.find(
          (res2Item) => res2Item.newsTitle === title
        );
        if (!findItem) {
          res2List.push(item);
        }
      });

      return res2List.slice(0,3);
    },
    // filterPointList(){
    //   let resList = []
    //   let errList = []
    //   this.viewPointList.forEach(item=>{
    //     let isSuccess =  this.fitlerHtml(item.Content)
    //     if(isSuccess){
    //       resList.push(item)
    //     }else {
    //       errList.push(item)
    //     }
    //   })
    //   return resList
    // },
    priceCarouseIndexList() {
      const defaultShowLenght = 4;
      const resList = [];

      let firDistance = this.carouselPriceIndex - 1;
      if (firDistance <= 0) {
        firDistance = firDistance + this.viewPointList.length;
      }

      resList.push(firDistance);

      for (let index = 0; index < defaultShowLenght; index++) {
        let distance = this.carouselPriceIndex + index;
        if (distance > this.viewPointList.length) {
          distance = distance - this.viewPointList.length;
        }
        if (firDistance <= 0) {
          firDistance = firDistance + this.viewPointList.length;
        }

        resList.push(distance);
      }

      let tailDistance = this.carouselPriceIndex + defaultShowLenght;
      if (tailDistance > this.viewPointList.length) {
        tailDistance = tailDistance - this.viewPointList.length;
      }
      resList.push(tailDistance);

      return resList;
    },
    priceCarouselItemStyle() {
      const defaultShowLenght = 4;

      const defaultItemHeight = 100;
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.priceCarouseIndexList.findIndex(
          (item) => item === currenIndex
        );

        if (findIndex < 0) {
          return {
            top: (defaultShowLenght + 1) * defaultItemHeight + "px",
          };
        }
        return {
          top: (findIndex - 1) * defaultItemHeight + "px",
        };
      };
    },
    priceCarouselItemShow() {
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.priceCarouseIndexList.findIndex(
          (item) => item === currenIndex
        );

        if (findIndex <= 0) {
          return "carousel-hidden-item";
        }
        if (findIndex === this.priceCarouseIndexList.length - 1) {
          return "carousel-hidden-item";
        }
        return "carousel-normal-item";
      };
    },
  },
  mounted() {
    // this.scrollIng();
    // this.initHandleMouse();
  },
  updated(){
    this.removeAlinkAttr("viewPointcontainer");
  },
  methods: {
    removeAlinkAttr(eleId) {
        let aContainer = this.$refs[eleId]
        
        if (!aContainer) {
          return;
        }
        let alist = aContainer.getElementsByTagName("a");
        for (let index = 0; index < alist.length; index++) {
          const element = alist[index];

          element.removeAttribute("href");
          element.removeAttribute("target");

          // element.setAttribute('data-id',index)
        }
    },
    filterPContent(htmlContet) {
      const minTextLength = 15;
      const parser = new DOMParser();
      let doc = parser.parseFromString(htmlContet, "text/html");
      let pList = doc.querySelectorAll("p");
      let divDom = document.createElement("div");

      for (let index = 0; index < pList.length; index++) {
        const element = pList[index];
        let strContent = element.innerText;
        if (!(strContent.length < minTextLength)) {
          divDom.appendChild(element);
        }
      }

      return divDom.innerHTML;
    },
    fitlerHtml(htmlContet) {
      // let pfir = str.split('</p>')[0]
      // let dotIndex = pfir.indexOf('>')
      // let content = pfir.substring(dotIndex)
      // console.log(content)

      const minTextLength = 15;
      const parser = new DOMParser();
      let doc = parser.parseFromString(htmlContet, "text/html");
      let pfir = doc.querySelector("p");
      let strContent = pfir.innerText;
      if (strContent.length < minTextLength) {
        return false;
      }
      return true;
    },
    toRegister() {
      this.$emit("toRegister");
    },
    initHandleMouse() {
      let priceContainerDom = this.$refs['viewPointcontainer']
      priceContainerDom.addEventListener("mouseover", (e) => {
        this.scrollPause();
      });
      priceContainerDom.addEventListener("mouseout", (e) => {
        this.scrollIng();
      });
    },
    scrollPause() {
      if (this.setTodoFun) {
        clearInterval(this.setTodoFun);
      }
    },
    scrollIng() {
      this.setTodoFun = setInterval(() => {
        this.carouselPriceIndex++;
        if (this.carouselPriceIndex > this.viewPointList.length) {
          this.carouselPriceIndex = 1;
        }
      }, 2500);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  position: relative;
  height: calc(100% - 40px);

  .item {
    // position: absolute;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: 100%;
    height: 100px;
    padding: 10px;
    opacity: 0;
    transition: all 2500ms linear;
    transition-property: left, opacity;
    transform: translate3d(0, 0, 0);
    .item-content-box {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .item-head {
        font-size: 16px;
        height: 1.6rem;
        line-height: 1.6rem;

        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item-main {
        width: 100%;
        font-size: 14px;
        height: 2rem;
        // line-height: 2rem;

        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /deep/ p {
          text-indent: 0.5rem !important;
          display: inline-block;
          height: 1.5rem !important;
          line-height: 1.5rem !important;
          vertical-align: top;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .item-bottom {
      text-indent: 0.5rem;
      color: #999999;
    }
  }

  .item:nth-of-type(even) {
    background-color: #f8f8f8;
  }
  .carousel-hidden-item {
    opacity: 0;
  }
  .carousel-normal-item {
    opacity: 1;
  }
}

@media (min-width: 1280px) {
  .card-box {
    .item {
      padding: 15px 20px;

      .item-content-box {
      }
    }
  }
}
</style>
